module.exports = "<div>\n    <h2>Not Implemented</h2>\n    <p>This feature is not implemented yet, will be available in the next releases.</p>\n</div>\n";